module.exports = __webpack_public_path__ + "img/c277f66.png";